import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

//Compponent
import DashboardNavigation from '../organisms/DashboardNavigation/DashboardNavigationContainer';
import BotBox from '../molecules/BotBox';
import Button from '../atoms/Button';
import FormCreateBot from '../organisms/FormCreateBot/FormCreateBotContainer';
import FormDeleteBot from '../organisms/FormDeleteBot/FormDeleteBotContainer';

class DashboardBots extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loginStatus: this.props.loginStatus,
			bots: [],
			currentBot: {},
			modalCreate: '',
			updateState: false,
			modalClassDelete: '',
			botName: ''
		}

		this.modalClickHandler = this.modalClickHandler.bind(this);
		this.modalClickOutside = this.modalClickOutside.bind(this);
		this.renderBotList = this.renderBotList.bind(this);
		this.toggleCheckbox = this.toggleCheckbox.bind(this);
	}
	componentWillMount() {
		// If the user hasn't verified his account, then call the server again
        if (!this.props.loginStatus || !this.props.loginStatus.data.verified) {
            this.props.fetchLoginStatus(); // Fetching the status from the server
        }
		this.props.fetchBots();
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			modalCreate: '',
			modalClassDelete: ''
		});
	}
	toggleCheckbox(e, item) {
		e.preventDefault();
		// Redirect to the FB page of that bot
		this.setState({ currentBot: item }, () => {
			this.setState({ checkboxStatus: true });
		})
	}
	modalClickHandler(e, item, type) {
		e.preventDefault();
		// Adding the current selected bot to the store
		this.props.selectBot(item);

		if ((this.state.modalCreate === '' && type === 'create' && this.state.modalClassDelete === '') || (this.state.modalCreate === '' && type === 'update' && this.state.modalClassDelete === '')) {
			this.setState({  modalCreate: 'modal--active', modalClassDelete: '' });
			if (type === 'update') {
				this.setState({ updateState: true });
			}
			document.addEventListener('keydown', this.modalClickOutside, false);
			document.addEventListener('click', (e) => this.modalClickOutside(e, type), false);
		} else if ((this.state.modalCreate === 'modal--active' && type === 'create' && this.state.modalClassDelete === '') || (this.state.modalCreate === 'modal--active' && type === 'update' && this.state.modalClassDelete === '')) {
			this.setState({  modalCreate: '', modalClassDelete: '' });
			if (type === 'update') {
				this.setState({ updateState: false });
			}
			document.removeEventListener('click', (e) => this.modalClickOutside(e, type), false);
		} else if (this.state.modalClassDelete === '' && type === 'delete' && this.state.modalCreate === '') {
			this.setState({ modalClassDelete: 'modal--active', modalCreate: '' });
			document.addEventListener('keydown', this.modalClickOutside, false);
			document.addEventListener('click', (e) => this.modalClickOutside(e, type), false);
		} else if (this.state.modalClassDelete === 'modal--active' && type === 'delete' && this.state.modalCreate === '') {
			this.setState({ modalClassDelete: '', modalCreate: '' });
			document.removeEventListener('click', (e) => this.modalClickOutside(e, type), false);
		}
	}
	modalClickOutside(e, type) {
		let targetClass = e.target.className;
		// Closing from the X
		if (targetClass.includes('fa-close') || e.keyCode === 27) { // Checking if they press ESC key
			this.setState({ 
				modalClassDelete: '',
				modalCreate: ''
			});
		}
		// ignore clicks on the component itself
		if (!targetClass.includes('modal--active')) {
			return;
		}
		this.modalClickHandler(e, null, type);
	}
	renderBotList(bots) {
		if (bots.length <= 0) { return false; }
		else {
			return (
				<div className="row">
					{bots.map((item, i) => {
						return (
							<div className="col-sm-12 col-md-6 col-lg-4" key={i} data-id={item._id}>
								{/* Maybe there's an easier way to make this /bots/:id/subjects (?)  */}
								<BotBox
									TextHeadingThree={item.name} href={`/bots/${item._id}/subjects`}
									labelText={item.subscriptions.length > 0 ? 'on' : 'off'}
									checked={item.subscriptions.length > 0 ? true : false}
									onChange={(e) => this.toggleCheckbox(e, item)}
									onClickDelete={(e) => this.modalClickHandler(e, item, 'delete')}
									onClickUpdate={(e) => this.modalClickHandler(e, item, 'update')}
								/>
							</div>
						)
					})}
				</div>
			)
		}
	}
	renderHandler(data, bots) {
		if (bots === undefined) { return false; }

		if (data.message === 'logged in' && !data.verified) { // If it is successfully logged in but the account is not verified
            return (
                <Redirect to={{
                    pathname: '/verify',
                    state: { from: this.props.location, storeLoginStatus: true } // This is the store state
                }}/>
            )
		}

		if (this.state.checkboxStatus) {
			return (
                <Redirect to={{
                    pathname: `/bots/${this.state.currentBot._id}/facebook`,
                    state: { from: this.props.location, storeLoginStatus: true } // This is the store state
                }}/>
            )
		}
		
		// Add loading screen to avoid rendering fast the component and then re-directing
		return (
			<div className="dashboardBody">
				<DashboardNavigation />
				<div className="dashboardMainContent">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<Button
									classType="btn btn--small btn--iconLeft margin-b-sm btn--fullWidthMobile"
									text={this.props.data.button.text}
									onClick={(e) => this.modalClickHandler(e, null, 'create')}
									iconLeft="fa-plus" />
							</div>
						</div>
						{this.renderBotList(bots)}
					</div>
				</div>
				<FormCreateBot
					modalClass={this.state.modalCreate}
					updateState={this.state.updateState}
					currentBots={this.state.bots}
				/>

				<FormDeleteBot
					modalClass={this.state.modalClassDelete}
					onClickCancel={(e) => this.modalClickHandler(e, null, 'delete')}
				/>
			</div>
		)
	}
	render() {
		const { data } = this.props.loginStatus; // Reads the store
		const bots = this.props.userBots.data; // Reads the store

		return this.renderHandler(data, bots);
	}
}

export default withRouter(DashboardBots);


// WEBPACK FOOTER //
// ./src/redux/components/templates/DashboardBots.jsx